const tradeMenu = {
  label: 'Trocar Reales',
  items: [
    {
      items: [],
      label: 'Extrato',
      title: 'null',
      icon: 'icon_listing',
      bannerInventory: 'null',
      type: 'static',
      dynamicAction: 'null',
      path: '/extract'
    },
    {
      items: [],
      label: 'Pedidos',
      title: 'null',
      icon: 'icon_package',
      bannerInventory: 'null',
      type: 'static',
      dynamicAction: 'null',
      path: '/my-orders'
    },
    {
      items: [],
      label: 'Recarga de celular',
      title: 'null',
      icon: 'icon_card',
      bannerInventory: 'null',
      type: 'static',
      dynamicAction: 'null',
      path: '/mobile-recharge'
    },
    {
      context: ['cash'],

      items: [],
      label: 'Compre e ganhe reales',
      title: 'null',
      icon: 'icon_cash',
      bannerInventory: 'null',
      type: 'static',
      dynamicAction: 'null',
      path: '/search'
    },
    {
      context: ['points'],

      items: [],
      label: 'Troque seus reales',
      title: 'null',
      icon: 'icon_gift',
      bannerInventory: 'null',
      type: 'static',
      dynamicAction: 'null',
      path: '/search'
    }
  ]
}

export default tradeMenu



// WEBPACK FOOTER //
// ./src/redux/initial-state/tradeMenu.js